import React from 'react'
import {HiOutlineArrowLongRight} from 'react-icons/hi2'
import {BsFillSendFill} from 'react-icons/bs'
import {IoMdCall} from 'react-icons/io'
import {AiFillYoutube} from 'react-icons/ai'
import {HiOutlineArrowRight} from 'react-icons/hi'
import {FiPhoneCall} from 'react-icons/fi'
import log from '../../img/check1.png'
import log1 from '../../img/ins2.png'
import ss from '../../img/Layer.png'
import ima from '../../img/ima.png'
import ima1 from '../../img/imaa.png'
import Carousel from 'better-react-carousel'; 
import Footer from '../Footer/Footer' 
import Model from '../Model/Model'
import Header from '../Header/Header'

const cogniCampuX = () => {
  return (
    <>
     <Header/>
    <section style={{backgroundColor:'#ECF0F9',paddingTop:'110px'}}> 
    <div className='container pb-4'>
     <div className='row'>

      <div className='col-lg-6 col-md-6 col-sm-12'>
      
      <h2>Automate & Scale your<br/>
      Education Business with <HiOutlineArrowLongRight className='ms-3' /></h2> 

      </div>

      <div className='col-lg-4 col-md-6 col-sm-12'>
       
      </div>

      <div className='col-lg-2 col-md-6 col-sm-12'>
      <div className='Get'>
      <button type='btn ' className='mm1' data-bs-toggle="modal" data-bs-target="#exampleModal" style={{backgroundColor:'#000', color:'#fff', padding:'8px 20px', borderRadius:'10px', width:'auto'}}> <BsFillSendFill className='me-2'/>  Get Started</button><br></br><br></br>
      <button type='btn' className='mm1'  data-bs-toggle="modal" data-bs-target="#exampleModal" style={{backgroundColor:'#177FFC', color:'#fff', padding:'8px 30px', borderRadius:'10px', width:'auto', border:'none'}}> <IoMdCall className='me-2'/>Talk to Us</button>
    </div>
      </div>

     </div>



     <div className='row mt-4'>
      <div className='col-lg-2 col-md-6 col-sm-12 mt-3'>
      
         <img src={log} alt="img" style={{width:'100%'}}/>
      </div>
      <div className='col-lg-8 col-md-6 col-sm-12 mt-3'>
      
         <img src={log1} alt="img" style={{width:'100%'}}/>
      </div>
       
     </div>
    </div>
    </section>


    <section>
     <div className='container mt-5'>
      <div className='row'>
       <div className='col-lg-5 col-md-6 col-sm-12'>

       <div style={{display:'flex', alignItems:'center', justifyContent:'space-between'}}>
        
       <h3>Features & Modules</h3> 
        <button type='btn' className='text-nowrap'  style={{backgroundColor:'#ECF4FF', color:'#3572FA', border:'none', padding:'10px 12px'}}>  <AiFillYoutube className='me-3' style={{fontSize:'25px', color:'red', borderRadius:'10px'}}/>  Watch Demo</button>
        </div>
       </div>
      </div>
      </div>
    </section>


    <section>
     <div className='container'>
      <div className='row'>
      <div className='col-lg-9 col-sm-12'>
          

      <div className='row mt-3 '>
       <div className='col-lg-6 col-sm-12 mt-4'>
       <div class="card"  style={{borderRadius:'10px'}}>
 
<div class="card-body">
  <h5 class="card-title">Live Fees Monitoring</h5>
  <p class="card-text" style={{color:'#6a6a6a'}}>Fees collection is always a chaos, but With Cogni CampX it’s a piece of Cake , our intelligent algorithm identifies your revenue metrics and help you maintain a healthy cash flow automatically along with the list of Defaulters.</p>

  <button style={{backgroundColor:'#EFFFF6', color:'#0CCE7D', border:'none',padding:'10px', borderRadius:'10px'}}>Included with Free Plan</button>
</div>
</div>
       </div>


       <div className='col-lg-6 col-sm-12 mt-4'>
       <div class="card"  style={{borderRadius:'10px'}}>
 
<div class="card-body">
  <h5 class="card-title">Automatic Fees Collection</h5>
  <p class="card-text" style={{color:'#6a6a6a'}}>Our Financing solutions are built into the very same system which allows Educational institutes to set up E NACH for automatic fees Collection. We also provide Education Loan to Students.</p>

  <button style={{backgroundColor:'#FFEFEF', color:'#FB1C1C', border:'none',padding:'10px', borderRadius:'10px'}}>Not Included with Free Plan</button>
</div>
</div>
       </div>
      
      </div> 


      
      <div className='row mt-3 '>
       <div className='col-lg-6 col-sm-12 mt-4'>
       <div class="card"  style={{borderRadius:'10px'}}>
 
          <div class="card-body">
            <h5 class="card-title">Task Monitoring</h5>
            <p class="card-text" style={{color:'#6a6a6a'}}>You can easily manage task given to your team along with your daily Schedule management, which we provide for absolutely zero cost, so your Time Management does not takes up your time.</p>

            <button style={{backgroundColor:'#EFFFF6', color:'#0CCE7D', border:'none',padding:'10px', borderRadius:'10px'}}>Included with Free Plan</button>
          </div>
          </div>
       </div>


       <div className='col-lg-6 col-sm-12 mt-4'>
       <div class="card"  style={{borderRadius:'10px'}}>
 
<div class="card-body">
  <h5 class="card-title">Vendor Management & Payouts </h5>
  <p class="card-text" style={{color:'#6a6a6a'}}>Are you Tired of maintaining all the bills and accounts?, Vendor payments and their management is also a headache for you, than Cogni CampX provides you with In built Vendor Management & Payout Solutions.</p>

  <button className='  ' style={{backgroundColor:'#FFEFEF', color:'#FB1C1C', border:'none',padding:'10px', borderRadius:'10px'}}>Not Included with Free Plan</button>
</div>
</div>
       </div>
      
      </div>

      



      
      <div className='row mt-3 '>
       <div className='col-lg-6 col-sm-12 mt-4'>
       <div class="card"  style={{borderRadius:'10px'}}>
 
<div class="card-body">
  <h5 class="card-title">HR & Payroll Automation</h5>
  <p class="card-text" style={{color:'#6a6a6a'}}>Now don’t worry about maintaining salary records and leave management or New employee onboarding or employee Exit, everything is just a click away with Cogni CampX’s in built HR & Payroll Management System.</p>

  <button className='   ' style={{backgroundColor:'#FFEFEF', color:'#FB1C1C', border:'none',padding:'10px', borderRadius:'10px'}}>Not Included with Free Plan</button>
</div>
</div>
       </div>


       <div className='col-lg-6 col-sm-12 mt-4'>
       <div class="card"  style={{borderRadius:'10px'}}>
 
<div class="card-body">
  <h5 class="card-title">Sales & Lead Management</h5>
  <p class="card-text" style={{color:'#6a6a6a'}}>Tracking the lead status and conversion rate has never been so easy before Cogni CampX’s Intelligent Employee Tracking & Lead Tracking feature, which gives you a flexibility to make more précised decisions </p>

  <button className='' style={{backgroundColor:'#EFFFF6', color:'#0CCE7D', border:'none',padding:'10px', borderRadius:'10px'}}>Included with Free Plan</button>
</div>
</div>
       </div>
      
      </div>





      <div className='row mt-3 '>
       <div className='col-lg-6 col-sm-12 mt-4'>
       <div class="card"  style={{borderRadius:'10px'}}>
 
<div class="card-body">
  <h5 class="card-title">Accounts Automation</h5>
  <p class="card-text" style={{color:'#6a6a6a'}}>Managing huge accounts and every minute transactions using traditional ERPs is a headache, automate this manual task with our Intelligent Accounting algorithm which does all the Credits, Debits & Taxes automatically.</p>

  <button style={{backgroundColor:'#FFEFEF', color:'#FB1C1C', border:'none',padding:'10px', borderRadius:'10px'}}>Included with Free Plan</button>
</div>
</div>
       </div>


       <div className='col-lg-6 col-sm-12 mt-4'>
       <div class="card"  style={{borderRadius:'10px'}}>
 
<div class="card-body">
  <h5 class="card-title">Team Management </h5>
  <p class="card-text" style={{color:'#6a6a6a'}}>Easily manage your entire team, Add or Remove Employee within One Click along with managing their access with just 2 Clicks, we have all of that. Sit Back and Relax Cogni CampuX is their to automate it for you.</p>

  <button className='   ' style={{backgroundColor:'#EFFFF6', color:'#0CCE7D', border:'none',padding:'10px', borderRadius:'10px'}}>Included with Free Plan</button>
</div>
</div>
       </div>
      
      </div>
       
      </div>
      </div>
     </div>
    </section>



    <section>
     <div className='container mt-5'>
      <div className='row'>
      <div className='col-lg-6 col-md-6 col-sm-12 mt-3'>
      
      <h2>Genuis StriX Student App <HiOutlineArrowRight className='ms-2'/></h2>

      <div>
      <button className=' mt-2  ' style={{backgroundColor:'#FFEFEF', color:'#FB1C1C', border:'none',padding:'10px', borderRadius:'10px'}}>Included with Free Plan </button>
      </div>
      </div>




      <div className='col-lg-4 col-md-6 col-sm-12'> 
   
      </div>


      <div className='col-lg-2 col-md-6 col-sm-12 mt-3'>   
      <div>
      <button type='btn'  data-bs-toggle="modal" data-bs-target="#exampleModal" style={{backgroundColor:'#177FFC', color:'#fff', padding:'8px 30px', borderRadius:'10px', width:'auto', border:'none'}}> <FiPhoneCall className='me-2'/>  Talk to Us</button>
      </div>
      
      </div>
      </div>
     </div>
    </section>




    <section>
     <div className='container'>
     <div className='row'>
      <div className='col-lg-5 col-sm-12 mt-5' >


      <div style={{display:'flex', justifyContent:'center'}}>
      <img src={ss} alt='#'  style={{width:'80%'}}/>
      
      </div> 
      </div> 


      <div className='col-lg-1 col-sm-12 mt-5' >
       </div>
      <div className='col-lg-6 col-sm-12 mt-5' >
      
      <h3>Now let your Students experience <br/> your world class education on your<br/> “Own” App</h3>


      <div className='row'>
       <div className='col-lg-4 col-md-6 col-sm-12 mt-3 '>
          <h6 style={{color:'#0AC677', backgroundColor:'#E6FFF4', fontSize:'15px', padding:'10px 12px', borderRadius:'10px',textAlign:'center'}}>Beautiful User Interface</h6>
       </div>

       <div className='col-lg-3 col-md-6 col-sm-12 mt-3 '>
       <h6 style={{color:'#0AC677', backgroundColor:'#E6FFF4', fontSize:'15px', padding:'10px 12px', borderRadius:'10px',textAlign:'center'}}>White Label </h6>
    </div>

       <div className='col-lg-4 col-md-6 col-sm-12 mt-3 '>
       <h6 style={{color:'#0AC677', backgroundColor:'#E6FFF4', fontSize:'15px', padding:'10px 12px', borderRadius:'10px',textAlign:'center'}}>Features Loaded </h6>
    </div>
      </div>

      <div className='row'>
      <div className='col-lg-6 col-md-6 col-sm-12 mt-3 '>
         <h6 style={{color:'#0AC677', backgroundColor:'#E6FFF4', fontSize:'15px', padding:'10px 12px', borderRadius:'10px',textAlign:'center'}}>Desktop & Mobile Phone Friendly</h6>
      </div> 

      <div className='col-lg-6 col-md-6 col-sm-12 mt-3 '>
      <h6 style={{color:'#0AC677', backgroundColor:'#E6FFF4', fontSize:'15px', padding:'10px 12px', borderRadius:'10px',textAlign:'center'}}>Works on Low spec smartphones  </h6>
   </div>
     </div>

      <div className='row'>
      <div className='col-lg-6 col-md-6 col-sm-12 mt-3 '>
         <h6 style={{color:'#0AC677', backgroundColor:'#E6FFF4', fontSize:'15px', padding:'10px 12px', borderRadius:'10px',textAlign:'center'}}>In Built Payments Reminder</h6>
      </div>  
     </div>
  

     <div className='mt-3'>
      <h5>Platforms Supported</h5>
     </div>

     <div className='row'>
      <div className='col-lg-3 col-md-6 col-sm-12 mt-3'>
       
      <img src={ima1} alt='#' style={{width:'100%'}}/>
      </div>
      <div className='col-lg-3 col-md-6 col-sm-12 mt-3'>
       
      <img src={ima} alt='#' style={{width:'100%'}}/>
      </div>

      <p className='mt-2' style={{color:'#FB1C1C'}}>*Additional charges Applicable</p>
     </div>


      </div> 

     </div>
      </div>
    </section>



    <section>
     <div className='container mt-5'>
      <div className='row'>

       <div className='col-lg-6 col-md-6 col-sm-12 mt-4'> 
        
       <button type='btn' data-bs-toggle="modal" data-bs-target="#exampleModal" style={{backgroundColor:'#000', color:'#fff', padding:'8px 20px', borderRadius:'10px', width:'100%'}}> <BsFillSendFill className='me-2'/>  Get Started</button> 
       
     </div>
     

       <div className='col-lg-6 col-md-6 col-sm-12 mt-4'> 
        
     
       
       <button type='btn'  data-bs-toggle="modal" data-bs-target="#exampleModal" style={{backgroundColor:'#177FFC', color:'#fff', padding:'8px 30px', borderRadius:'10px', width:'100%', border:'none'}}> <IoMdCall className='me-2'/>  Talk to Us</button>
       
     </div>

       </div>
       </div> 
    </section>


    


    <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"  style={{backdropFilter:'blur(5px)'}}>
        <div class="modal-dialog modal-dialog-centered modal-lg" >
          <div class="modal-content"  style={{paddingTop:'0%'}}>
             

          <div class="modal-body">

                <Model/>
          </div>
            
          </div>
        </div>
      </div>



 <section className='mt-4'>
  <Footer/>
 </section> 
    </>
  )
}

export default cogniCampuX
